import React from "react";
import { AlertCircle, X } from "lucide-react";
import "./B2BErrorMessage.css";

interface B2BErrorMessageProps {
  error: string | null | undefined;
  onDismiss?: () => void;
  className?: string;
  variant?: "default" | "inline" | "banner";
  showIcon?: boolean;
}

/**
 * Reusable error message component for B2B flows
 * Provides consistent error display across components
 */
const B2BErrorMessage: React.FC<B2BErrorMessageProps> = ({
  error,
  onDismiss,
  className = "",
  variant = "default",
  showIcon = true,
}) => {
  if (!error) return null;

  const variantClasses = {
    default: "b2b-error-default",
    inline: "b2b-error-inline",
    banner: "b2b-error-banner",
  };

  return (
    <div
      className={`b2b-error-message ${variantClasses[variant]} ${className}`}
    >
      {showIcon && <AlertCircle className="b2b-error-icon" />}
      <span className="b2b-error-text">{error}</span>
      {onDismiss && (
        <button
          onClick={onDismiss}
          className="b2b-error-dismiss"
          aria-label="Dismiss error"
        >
          <X size={16} />
        </button>
      )}
    </div>
  );
};

export default B2BErrorMessage;

